import wywLog from '@/utils/ubcLog';

/**
 * 曝光指令
 * v-click="{serverId: 1xxxx, area: 'somearea'}"   --曝光打点
 * @param {Object} value 传入打点对象
 * @param {string} value.area 打点area
 * @param {string|number} value.serverId 打点id
 * @param {Object} value.ext 其余打点信息
 */
export default {
    // 只调用一次，指令第一次绑定到元素时调用。在这里进行初始化设置。
    bind(el, {value}) {
        // 1. 先定义函数（确保 add 和 remove 使用同一个引用）
        el._handleClick = () => {
            const {serverId, area, ext} = value || {};
            wywLog.send({
                area,
                action: 'click',
                serverId,
                ...ext
            });
        };
        el.addEventListener('click', el._handleClick);
    },
    // 指令与元素解绑的时候，移除事件绑定
    unbind(el) {
        el.removeEventListener('click', el._handleClick);
        delete el._handleClick;// 清理引用,防止内存泄漏
    }
};